module.exports = __webpack_public_path__ + "img/PC20240924-103854.c21b381d.png";